export const CREDIT_INCENTIVE_REQUESTED = 'CREDIT_INCENTIVE_REQUESTED'
export const CREDIT_INCENTIVE_SUCCEEDED = 'CREDIT_INCENTIVE_SUCCEEDED'
export const CREDIT_INCENTIVE_FAILED = 'CREDIT_INCENTIVE_FAILED'
export const RESET_CREDIT_INCENTIVE_STATE = 'RESET_CREDIT_INCENTIVE_STATE'
export const BULK_INCENTIVE_MODE_ENABLED = 'BULK_INCENTIVE_MODE_ENABLED'
export const BULK_INCENTIVE_MODE_DISABLED = 'BULK_INCENTIVE_MODE_DISABLED'
export const SET_BULK_SELECTED_TIME_SLOTS = 'SET_BULK_SELECTED_TIME_SLOTS'